import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({ 
  name: 'dateFormatted',
  pure: false
})
export class FormatDatePipe implements PipeTransform {

  transform(value: string): string {
    return dayjs(value).format('LL');
  }
}
